import { Children, forwardRef, useMemo } from 'react';

import { styled, Popper } from '@mui/material';

// react-virtuoso
import { Virtuoso } from 'react-virtuoso';

const PopperComponent = styled(Popper)(({ theme }) => ({
    '& .MuiAutocomplete-listbox': {
        maxHeight: 'unset',
        overflowY: 'auto',
        overflowX: 'hidden',

        '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.primary.dark,
            borderRadius: '6px',
            transition: 'background-color 0.3s ease',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: theme.palette.primary.main,
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },

        scrollbarWidth: 'thin', // Firefox
        scrollbarColor: `${theme.palette.primary.dark} transparent`, // Firefox
    },
}));

const ListboxComponent = forwardRef(function ListboxComponent(props, ref) {
    const { children, role, style, ...other } = props;

    const itemData = useMemo(() => Children.toArray(children), [children]);

    return (
        <div
            ref={ref}
            {...other}
            role={role}
            style={{ ...style, width: '100%', height: Math.min(itemData.length * 50 + 16, 300) }}>
            <Virtuoso
                style={{ height: '100%' }}
                totalCount={itemData.length}
                itemContent={(index) => {
                    return <div style={{ fontSize: '14px' }}>{itemData[index]}</div>;
                }}
            />
        </div>
    );
});

export { PopperComponent, ListboxComponent };
